import React, { useEffect, createRef } from 'react';

// Components
import InvisibleButton from '@/views/components/buttons/InvisibleButton';

// Libraries
import classNames from 'classnames';

// Types
import ComparisonItem from '@/types/comparison-item';

// Utils
import { ITEM_COLORS } from '@/utils/colors';

interface ColorPickerProps {
  disabled?: boolean;
  item: ComparisonItem;
  onChange: (item: ComparisonItem, color: string) => void;
}

const ColorPicker: React.FC<ColorPickerProps> = ({ disabled, item, onChange }) => {
  const firstColorButtonRef = createRef<HTMLButtonElement>();

  useEffect(() => {
    firstColorButtonRef.current?.focus();
  }, []);

  const handleOnChange = (event: React.MouseEvent, color: string) => {
    if (item.color !== color) {
      onChange(item, color);
    }
    event.stopPropagation();
  };

  return (
    <div className={classNames('color-picker', { disabled })}>
      {ITEM_COLORS.map((color, i) => (
        <InvisibleButton
          ariaLabel={color}
          className={classNames('color-option-border', { selected: item.color === color })}
          data-testid={`colorPicker-button-${item._id}-${i}`}
          key={color}
          onClick={event => handleOnChange(event, color)}
          ref={i === 0 ? firstColorButtonRef : undefined}
        >
          <div className="color-option" style={{ backgroundColor: color }} />
        </InvisibleButton>
      ))}
    </div>
  );
};

export default ColorPicker;
